import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { mergeMap } from 'rxjs/operators';

import { RoutingService } from 'app/services/routing.service';

@Component({
    selector: 'ui-route-title',
    template: ''
})
export class UIRouteTitleComponent implements OnInit {

    private _defaultTitlte = 'ABBYY FlexiCapture Cloud';

    constructor(private _routingService: RoutingService,
        private _title: Title) {
    }

    ngOnInit() {
        this._routingService.routes
            .pipe(mergeMap((route) => route.data))
            .subscribe((event) => this._title.setTitle(event['title'] || this._defaultTitlte));
    }
}